import type { DealSourceParam } from '../types';

export const TAB_QUERY_PARAM = 'tab';
export const DEAL_ID_QUERY_PARAM = 'deal_id';
export const SOURCE_QUERY_PARAM = 'source';
export const SEARCH_TEXT_QUERY_PARAM = 'search_text';
// Expiring Soon's "View expired bonds" toggle. Absent means off, so a shared link only
// carries it when the user turned it on.
export const INCLUDE_EXPIRED_QUERY_PARAM = 'include_expired';

export const DEAL_SOURCE_PARAMS: DealSourceParam[] = ['atlas', 'monolith', 'msa', 'invite'];
